import { render, staticRenderFns } from "./Atualizacoes.vue?vue&type=template&id=77d4db1c&scoped=true&lang=pug&"
import script from "./Atualizacoes.vue?vue&type=script&lang=js&"
export * from "./Atualizacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d4db1c",
  null
  
)

export default component.exports